// ======================================================================
// FILE:
// src/modules/service_crm/services/serviceTicketService.js
//
// MODULE: Service CRM
// FEATURE: Service Ticket APIs
// ======================================================================

import axiosClient from "../../../api/axiosClient";




// ======================================================================
// LIST TICKETS
// ======================================================================
const listTickets = async (params = {}) => {

  const res = await axiosClient.get(
    "/api/service-crm/tickets",
    {
      params,
    }
  );

  return res.data.data;
};


// ======================================================================
// GET TICKET
// ======================================================================
const getTicket = async (id) => {

  const res = await axiosClient.get(
    `/api/service-crm/tickets/${id}`
  );

  return res.data.data;
};


// ======================================================================
// CREATE TICKET
// ======================================================================
const createTicket = async (payload) => {

  const res = await axiosClient.post(
    "/api/service-crm/tickets",
    payload
  );

  return res.data.data;
};


// ======================================================================
// UPDATE TICKET
// ======================================================================
const updateTicket = async (
  id,
  payload
) => {

  const res = await axiosClient.put(
    `/api/service-crm/tickets/${id}`,
    payload
  );

  return res.data.data;
};


// ======================================================================
// RESOLVE TICKET
// ======================================================================
const resolveTicket = async (
  id,
  payload
) => {

  const res = await axiosClient.post(
    `/api/service-crm/tickets/${id}/resolve`,
    payload
  );

  return res.data.data;
};


// ======================================================================
// CLOSE TICKET
// ======================================================================
const closeTicket = async (
  id,
  payload
) => {

  const res = await axiosClient.post(
    `/api/service-crm/tickets/${id}/close`,
    payload
  );

  return res.data.data;
};


// ======================================================================
// GET TICKET TIMELINE
// ======================================================================
const getTimeline = async (id) => {

  const res = await axiosClient.get(
    `/api/service-crm/tickets/${id}/timeline`
  );

  return res.data.data || [];
};

// ======================================================================
// LIST VISITS
// ======================================================================
const listVisits = async (ticketId) => {

  const res = await axiosClient.get(
    `/api/service-crm/tickets/${ticketId}/visits`
  );

  return res.data.data || [];
};


// ======================================================================
// ADD VISIT
// ======================================================================
const addVisit = async (
  ticketId,
  payload
) => {

  const res = await axiosClient.post(
    `/api/service-crm/tickets/${ticketId}/visits`,
    payload
  );

  return res.data.data;
};

// ======================================================================
// GET FEEDBACK
// ======================================================================
const getFeedback = async (ticketId) => {

  const res = await axiosClient.get(
    `/api/service-crm/tickets/${ticketId}/feedback`
  );

  return res.data.data || null;
};


// ======================================================================
// CREATE FEEDBACK
// ======================================================================
const createFeedback = async (
  ticketId,
  payload
) => {

  const res = await axiosClient.post(
    `/api/service-crm/tickets/${ticketId}/feedback`,
    payload
  );

  return res.data.data;
};


// ======================================================================
// UPDATE FEEDBACK
// ======================================================================
const updateFeedback = async (
  feedbackId,
  payload
) => {

  const res = await axiosClient.put(
    `/api/service-crm/feedback/${feedbackId}`,
    payload
  );

  return res.data.data;
};

// ======================================================================
// UPLOAD FEEDBACK ATTACHMENT
// ======================================================================

const uploadFeedbackAttachment = async (
  feedbackId,
  file
) => {

  const formData =
    new FormData();

  formData.append(
    "file",
    file
  );

  const res =
    await axiosClient.post(

      `/api/service-crm/feedback/${feedbackId}/attachment`,

      formData,

      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }

    );

  return res.data.data;

};

// ======================================================================
// DOWNLOAD FEEDBACK ATTACHMENT
// ======================================================================

const downloadFeedbackAttachment =
  async (
    feedbackId
  ) => {

    const res =
      await axiosClient.get(

        `/api/service-crm/feedback/${feedbackId}/attachment`,

        {
          responseType:
            "blob",
        }

      );

    return res.data;

  };

// ======================================================================
// DELETE FEEDBACK ATTACHMENT
// ======================================================================

const deleteFeedbackAttachment =
  async (
    feedbackId
  ) => {

    const res =
      await axiosClient.delete(

        `/api/service-crm/feedback/${feedbackId}/attachment`

      );

    return res.data.data;

  };

// ======================================================================
// START VISIT
// ======================================================================

const startVisit = async (
  visitId,
  payload
) => {

  const res =
    await axiosClient.post(

      `/api/service-crm/visits/${visitId}/start`,

      payload

    );

  return res.data.data;

};

// ======================================================================
// STOP VISIT
// ======================================================================

const stopVisit = async (
  visitId,
  payload
) => {

  const res =
    await axiosClient.post(

      `/api/service-crm/visits/${visitId}/stop`,

      payload

    );

  return res.data.data;

};
// ======================================================================
// EXPORT
// ======================================================================
const serviceTicketService = {

  listTickets,

  getTicket,

  createTicket,

  updateTicket,

  resolveTicket,

  closeTicket,

  getTimeline,

  listVisits,

  addVisit,

  getFeedback,

  createFeedback,

  updateFeedback,
    startVisit,

  stopVisit,
  uploadFeedbackAttachment,

downloadFeedbackAttachment,

deleteFeedbackAttachment,
};

export default serviceTicketService;